/**
 * Версия рантайм-бандла plp-widgets.
 *
 * Bump'аем вручную при breaking changes контракта тегов/атрибутов.
 * Цифра попадает в имя файла (`plp-widgets-v${VERSION}.js`) и в
 * `window.__plpWidgets.version`.
 */
export const VERSION = '1';
